
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { MoveRight } from "lucide-react";

export const SubmitButton = () => {
  const { t } = useTranslation('contact');
  
  return (
    <Button 
      type="submit"
      className="w-full group bg-gradient-to-r from-brand-blue to-brand-orange hover:opacity-90 transition-all duration-300"
    >
      <span>{t("form.submit")}</span>
      <MoveRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
    </Button>
  );
};
